import React from 'react';
import { AppShell, Burger, Group, Text, NavLink, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { 
  IconDashboard, 
  IconUsers, 
  IconSchool, 
  IconBook, 
  IconSettings,
  IconLogout 
} from '@tabler/icons-react';

const AdminLayout = ({ children }) => {
  const [opened, { toggle }] = useDisclosure();
  const navigate = useNavigate();
  const location = useLocation();
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  const navItems = [
    { label: 'Dashboard', icon: IconDashboard, href: '/admin/dashboard' },
    { label: 'Batch Manager', icon: IconSchool, href: '/admin/batches' },
    { label: 'All Members', icon: IconUsers, href: '/admin/members' },
    { label: 'Curriculum Manager', icon: IconBook, href: '/admin/curriculum' },
    { label: 'Classes Manager', icon: IconBook, href: '/admin/classes' },
    { label: 'Batch Settings', icon: IconSettings, href: '/admin/settings' },
  ];

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 250,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Burger
              opened={opened}
              onClick={toggle}
              hiddenFrom="sm"
              size="sm"
            />
            <Text size="lg" fw={600}>
              Advanced Manifestation Magic - Admin
            </Text>
          </Group>
          <Group>
            <Text size="sm">Welcome, {user?.username}</Text>
            <Button
              variant="light"
              color="red"
              size="sm"
              leftSection={<IconLogout size={16} />}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar p="md">
        {navItems.map((item) => (
          <NavLink
            key={item.href}
            href={item.href}
            label={item.label}
            leftSection={<item.icon size="1rem" />}
            active={location.pathname === item.href}
            onClick={(e) => {
              e.preventDefault();
              navigate(item.href);
              if (opened) toggle();
            }}
            mb="xs"
          />
        ))}
      </AppShell.Navbar>

      <AppShell.Main>
        {children}
      </AppShell.Main>
    </AppShell>
  );
};

export default AdminLayout;